import PageContainer from '@/common/components/PageContainer'
import GameTypeListing from '@/modules/game/components/GameType/components/GameTypeListing'
import Spinner from '@/common/components/Spinner'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { PermissionType } from '@/common/types'
import withUserPermission from '@/common/components/WithUserPermission'
import useQueryGetGameTypeList from '@/modules/game/api/hooks/useQueryGetGameTypeList'

function GameTypePage() {
	const { data, isLoading } = useQueryGetGameTypeList()

	if (isLoading || !data) return <Spinner />

	return (
		<PageContainer>
			<GameTypeListing data={data?.data || []} />
		</PageContainer>
	)
}

const GuardedGameTypePage = withUserPermission(GameTypePage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_GAME],
})
export default GuardedGameTypePage
